import * as actionTypes from './actionTypes'

export const wbLoadPreviewCustomScript = (type) => (dispatch) =>
  dispatch({
    type: actionTypes.WB_LOAD_PREVIEW_CUSTOM_SCRIPT,
    payload: {
      type,
    },
  })
